import { createClient } from './http';
import type { Notification, Task, TaskCreateRequest, TaskStats, TaskUpdateRequest } from './types';

const TASKS_API_BASE = import.meta.env.VITE_TASKS_API_BASE_URL ?? 'https://x-gis.xenus.dev/api/tasks';

const request = createClient(TASKS_API_BASE);

export type TaskFilters = {
  status?: string;
  priority?: string;
  search?: string;
  sort?: string;
};

function toQuery(filters: TaskFilters): string {
  const params = new URLSearchParams();
  if (filters.status) params.set('status', filters.status);
  if (filters.priority) params.set('priority', filters.priority);
  if (filters.search) params.set('search', filters.search);
  if (filters.sort) params.set('sort', filters.sort);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export const tasksApi = {
  listTasks: (filters: TaskFilters = {}) => request<Task[]>(`/tasks${toQuery(filters)}`, {}, true),

  taskStats: () => request<TaskStats>('/tasks/stats', {}, true),

  createTask: (body: TaskCreateRequest) =>
    request<Task>('/tasks', { method: 'POST', body: JSON.stringify(body) }, true),

  updateTask: (id: string, body: TaskUpdateRequest) =>
    request<Task>(`/tasks/${id}`, { method: 'PATCH', body: JSON.stringify(body) }, true),

  deleteTask: (id: string) => request<void>(`/tasks/${id}`, { method: 'DELETE' }, true),

  listNotifications: () => request<Notification[]>('/notifications', {}, true),

  unreadCount: () => request<{ unread: number }>('/notifications/unread-count', {}, true),

  markNotificationRead: (id: string) =>
    request<{ status: string }>(`/notifications/${id}/read`, { method: 'PATCH' }, true),
};
